export class ParamUtil {
    public static toRequestParams<T>(obj: any) {
        const params: RequestParam[] = [];
        Object.keys(obj).forEach((k) => {
            if (obj[k] !== undefined) {
                params.push(new RequestParam(k, obj[k]));
            }
        });
        return params;
    }

    public static toRequestParamsByValueAndKey<T>(values: [], key: string) {
        const params: RequestParam[] = [];
        values.forEach((val) => {
            params.push(new RequestParam(key, val));
        });
        return params;
    }

    public static convertToDate(date: string) {
        switch (date.toUpperCase()) {
            case "YEAR":
                return "YEARS";
            case "MONTH":
                return "YEAR";
            case "DAY":
                return "MONTH";
            case "DATE":
                return "DAY";
            default : return "YEAR";
        }
    }

    public static converToDateLength(date: string, dateType: string) {
        switch (dateType.toUpperCase()) {
            case "YEAR":
                return date.substring(0, 4);
            case "MONTH":
                return date.substring(0, 6);
            case "DAY":
                return date.substring(0, 8);
            default:
                return date.substring(0, 8);
        }
    }

}

export class RequestParam {
    name: string;
    value: string;

    constructor(name: string, value: string) {
        this.name = name;
        this.value = value;
    }

}



